var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 14.95L16.3 13.5C16.5333 13.1167 16.7083 12.7167 16.825 12.3C16.9417 11.8833 17 11.45 17 11H19C19 11.7333 18.8917 12.4292 18.675 13.0875C18.4583 13.7458 18.15 14.3667 17.75 14.95ZM14.8 11.95L13 10.15V5C13 4.71667 12.9042 4.47917 12.7125 4.2875C12.5208 4.09583 12.2833 4 12 4C11.7167 4 11.4792 4.09583 11.2875 4.2875C11.0958 4.47917 11 4.71667 11 5V8.15L9 6.15V5C9 4.16667 9.29167 3.45833 9.875 2.875C10.4583 2.29167 11.1667 2 12 2C12.8333 2 13.5417 2.29167 14.125 2.875C14.7083 3.45833 15 4.16667 15 5V11C15 11.1833 14.9792 11.35 14.9375 11.5C14.8958 11.65 14.85 11.8 14.8 11.95ZM11 21V17.925C9.26667 17.6917 7.83334 16.9167 6.7 15.6C5.56667 14.2833 5 12.75 5 11H7C7 12.3833 7.47917 13.5625 8.4375 14.5375C9.39584 15.5125 10.5833 16 12 16C12.5667 16 13.1042 15.9125 13.6125 15.7375C14.1208 15.5625 14.5833 15.3167 15 15L16.425 16.425C15.9417 16.8083 15.4125 17.1333 14.8375 17.4C14.2625 17.6667 13.65 17.8417 13 17.925V21H11ZM19.8 22.6L1.4 4.2L2.8 2.8L21.2 21.2L19.8 22.6Z",
    fill: "#873CAA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic_off.f328f990efbd23ecb59a73b57b404078.svg";
export { ForwardRef as ReactComponent };